import React, { useState, useEffect } from 'react';
import AdminPanel from './AdminPannel'; // Assuming AdminPannel.js is in the same directory

const UploadPost = () => {
    const [posts, setPosts] = useState([]);
    const [images, setImages] = useState([]);
    const [videos, setVideos] = useState([]);
    const [description, setDescription] = useState('');
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
    const [isMobileNavVisible, setIsMobileNavVisible] = useState(false);
    const [selectedPlatforms, setSelectedPlatforms] = useState([]);
    const allPlatforms = ['YouTube', 'Facebook', 'Instagram', 'LinkedIn', 'Email', 'All'];
    const [mediaType, setMediaType] = useState('Both');
    const [numImages, setNumImages] = useState(1);
    const [numVideos, setNumVideos] = useState(1);

    // --- Start of new state for Email specific fields ---
    const [emailSubject, setEmailSubject] = useState('');
    const [emailHeading, setEmailHeading] = useState('');
    // --- End of new state for Email specific fields ---

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleSidebarCollapse = (collapsed) => {
        setIsSidebarCollapsed(collapsed);
    };

    const handleMobileNavVisibility = (visible) => {
        setIsMobileNavVisible(visible);
    };

    const handlePlatformChange = (platform) => {
        if (platform === 'All') {
            if (selectedPlatforms.includes('All')) {
                setSelectedPlatforms([]);
            } else {
                // Select all platforms except 'All' itself
                setSelectedPlatforms([...allPlatforms.filter(p => p !== 'All')]);
            }
        } else {
            const currentIndex = selectedPlatforms.indexOf(platform);
            let newSelectedPlatforms = [...selectedPlatforms];

            if (currentIndex === -1) {
                newSelectedPlatforms.push(platform);
            } else {
                newSelectedPlatforms.splice(currentIndex, 1);
            }
            setSelectedPlatforms(newSelectedPlatforms);
        }
    };

    useEffect(() => {
        // Auto-check/uncheck 'All' based on other selections
        const allOtherPlatformsSelected = allPlatforms.filter(p => p !== 'All').every(p => selectedPlatforms.includes(p));
        const allOptionSelected = selectedPlatforms.includes('All');

        if (allOtherPlatformsSelected && !allOptionSelected) {
            setSelectedPlatforms([...selectedPlatforms, 'All']);
        } else if (!allOtherPlatformsSelected && allOptionSelected) {
            setSelectedPlatforms(selectedPlatforms.filter(p => p !== 'All'));
        }

        // --- Logic to clear email fields if Email is deselected ---
        if (!selectedPlatforms.includes('Email')) {
            setEmailSubject('');
            setEmailHeading('');
        }
        // --- End of logic ---

    }, [selectedPlatforms, allPlatforms]);


    const handleMediaTypeChange = (type) => {
        setMediaType(type);
        setImages([]);
        setVideos([]);
        setNumImages(1);
        setNumVideos(1);
    };

    const handleNumImagesChange = (e) => {
        const num = parseInt(e.target.value, 10);
        const newNumImages = Math.max(1, Math.min(5, num || 1)); // Ensure num is at least 1
        setNumImages(newNumImages);
        setImages(Array(newNumImages).fill(null));
    };

    const handleNumVideosChange = (e) => {
        const num = parseInt(e.target.value, 10);
        const newNumVideos = Math.max(1, Math.min(5, num || 1)); // Ensure num is at least 1
        setNumVideos(newNumVideos);
        setVideos(Array(newNumVideos).fill(null));
    };

    const handleImageChange = (e, index) => {
        const newImages = [...images];
        newImages[index] = e.target.files[0];
        setImages(newImages);
    };

    const handleVideoChange = (e, index) => {
        const newVideos = [...videos];
        newVideos[index] = e.target.files[0];
        setVideos(newVideos);
    };

    const handleDescriptionChange = (e) => {
        setDescription(e.target.value);
    };

    // --- Handlers for new Email fields ---
    const handleEmailSubjectChange = (e) => {
        setEmailSubject(e.target.value);
    };

    const handleEmailHeadingChange = (e) => {
        setEmailHeading(e.target.value);
    };
    // --- End of Handlers for new Email fields ---

    const handleSubmit = (e) => {
        e.preventDefault();
        const currentTime = new Date();
        const newPost = {
            id: Date.now(),
            images: mediaType === 'Image' || mediaType === 'Both' ? images.filter(img => img !== null) : [],
            videos: mediaType === 'Video' || mediaType === 'Both' ? videos.filter(vid => vid !== null) : [],
            description: description,
            uploadDateTime: currentTime.toLocaleString(),
            platforms: selectedPlatforms,
        };

        // --- Add email specific fields to post if Email platform is selected ---
        if (selectedPlatforms.includes('Email')) {
            newPost.emailSubject = emailSubject;
            newPost.emailHeading = emailHeading;
        }
        // --- End of adding email specific fields ---

        setPosts([...posts, newPost]);
        setImages(Array(numImages).fill(null)); // Reset based on current numImages
        setVideos(Array(numVideos).fill(null)); // Reset based on current numVideos
        setDescription('');
        setSelectedPlatforms([]);
        setMediaType('Both');
        // setNumImages(1); // No need to reset numImages/numVideos here, keep user's last selection
        // setNumVideos(1);
        setEmailSubject(''); // Reset email fields
        setEmailHeading(''); // Reset email fields
        console.log('Post uploaded:', newPost);
    };


    const handleEdit = (id) => {
        console.log(`Edit post with ID: ${id}`);
        // Implementation for editing would go here
        // You might want to populate the form fields with the post data
    };

    const handleDelete = (id) => {
        setPosts(posts.filter(post => post.id !== id));
    };

    // --- Styles (Copied from your original code, ensure they are complete) ---
    const containerStyle = {
        display: 'flex',
        flexDirection: windowWidth <= 768 ? 'column' : 'row',
        minHeight: '100vh',
    };

    const contentStyle = {
        padding: '20px',
        fontFamily: 'Arial, sans-serif',
        marginLeft: windowWidth > 768 ? (isSidebarCollapsed ? '64px' : '250px') : '0',
        marginTop: windowWidth <= 768 ? '0' : '20px', // Adjusted for mobile
        boxSizing: 'border-box',
        flexGrow: 1,
    };

    const headingStyle = {
        color: '#333',
        marginBottom: '15px',
    };

    const mediaTypeSelectionStyle = {
        marginBottom: '20px',
        padding: '15px',
        border: '1px solid #ddd',
        borderRadius: '5px',
        backgroundColor: '#f9f9f9',
    };

    const platformSelectionStyle = {
        marginBottom: '20px',
        padding: '15px',
        border: '1px solid #ddd',
        borderRadius: '5px',
        backgroundColor: '#f9f9f9',
    };

    const platformCheckboxStyle = {
        marginRight: '15px', // Increased spacing
        display: 'inline-block', // Ensure proper layout
        marginBottom: '5px', // Add some bottom margin for wrapped items
    };

    const numberSelectionStyle = {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '10px',
    };

    const numberInputStyle = {
        width: '60px', // Slightly wider
        padding: '8px', // Consistent padding
        marginLeft: '10px',
        border: '1px solid #ccc',
        borderRadius: '4px',
    };

    const formGroupStyle = {
        marginBottom: '15px',
    };

    const labelStyle = {
        display: 'block',
        marginBottom: '5px',
        fontWeight: 'bold',
    };

    const inputStyle = {
        width: '100%',
        padding: '8px',
        border: '1px solid #ccc',
        borderRadius: '4px',
        boxSizing: 'border-box',
    };

    const textareaStyle = {
        width: '100%',
        padding: '8px',
        border: '1px solid #ccc',
        borderRadius: '4px',
        boxSizing: 'border-box',
        minHeight: '80px', // Ensure decent height
    };

    const imagePreviewStyle = {
        maxWidth: '100px', // Slightly larger preview
        maxHeight: '100px',
        marginRight: '10px',
        marginBottom: '10px',
        border: '1px solid #eee',
        borderRadius: '4px',
        objectFit: 'cover',
    };

    const videoPreviewStyle = {
        maxWidth: '160px', // Slightly larger preview
        maxHeight: '120px',
        marginRight: '10px',
        marginBottom: '10px',
        border: '1px solid #eee',
        borderRadius: '4px',
    };

    const buttonStyle = {
        padding: '10px 20px', // More padding
        backgroundColor: '#007bff',
        color: 'white',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '16px',
        transition: 'background-color 0.3s ease', // Smooth transition
    };

    // const buttonHoverStyle = { // Inline this for simplicity or use pseudo-classes
    //     backgroundColor: '#0056b3',
    // };

    const tableStyle = {
        width: '100%',
        borderCollapse: 'collapse',
        marginTop: '20px', // More space above table
    };

    const tableHeaderCellStyle = {
        border: '1px solid #ddd',
        padding: '10px 12px', // More padding
        textAlign: 'left',
        backgroundColor: '#f2f2f2',
        fontWeight: 'bold', // Bold headers
    };

    const tableCellStyle = {
        border: '1px solid #ddd',
        padding: '10px 12px', // More padding
        textAlign: 'left',
        verticalAlign: 'top', // Align content to top for multi-line
    };

    const tableRowEvenStyle = {
        backgroundColor: '#f9f9f9',
    };

    // const tableRowHoverStyle = { // Handled by pseudo-classes in JSX if preferred
    //     backgroundColor: '#e0e0e0',
    // };

    const tableActionButtonStyle = {
        marginRight: '8px', // More spacing
        fontSize: '14px',
        padding: '6px 10px', // Adjust padding
        cursor: 'pointer',
        borderRadius: '4px',
        border: '1px solid #ccc',
    };
    const editButtonStyle = {
        ...tableActionButtonStyle,
        backgroundColor: '#ffc107', // Yellow for edit
        color: '#333',
    };
    const deleteButtonStyle = {
        ...tableActionButtonStyle,
        backgroundColor: '#dc3545', // Red for delete
        color: 'white',
    };


    const noPostsStyle = {
        marginTop: '20px', // More space
        fontStyle: 'italic',
        color: '#777',
        textAlign: 'center', // Center the message
    };


    return (
        <div style={containerStyle}>
            <AdminPanel onSidebarCollapse={handleSidebarCollapse} onMobileNavVisibility={handleMobileNavVisibility} />
            <div style={contentStyle}>
                <h2 style={headingStyle}>Upload New Post</h2>

                <div style={mediaTypeSelectionStyle}>
                    <h3 style={{ marginTop: 0, marginBottom: '10px' }}>Select Media Type:</h3>
                    <label style={{ marginRight: '15px' }}>
                        <input
                            type="radio"
                            value="Image"
                            checked={mediaType === 'Image'}
                            onChange={(e) => handleMediaTypeChange(e.target.value)}
                        />
                        Image
                    </label>
                    <label style={{ marginRight: '15px' }}>
                        <input
                            type="radio"
                            value="Video"
                            checked={mediaType === 'Video'}
                            onChange={(e) => handleMediaTypeChange(e.target.value)}
                        />
                        Video
                    </label>
                    <label>
                        <input
                            type="radio"
                            value="Both"
                            checked={mediaType === 'Both'}
                            onChange={(e) => handleMediaTypeChange(e.target.value)}
                        />
                        Both
                    </label>
                </div>

                {(mediaType === 'Image' || mediaType === 'Both') && (
                    <div style={numberSelectionStyle}>
                        <label htmlFor="numImages" style={{fontWeight: 'normal'}}>Number of Images (1-5):</label>
                        <input
                            type="number"
                            id="numImages"
                            value={numImages}
                            onChange={handleNumImagesChange}
                            min="1"
                            max="5"
                            style={numberInputStyle}
                        />
                    </div>
                )}

                {(mediaType === 'Video' || mediaType === 'Both') && (
                    <div style={numberSelectionStyle}>
                        <label htmlFor="numVideos" style={{fontWeight: 'normal'}}>Number of Videos (1-5):</label>
                        <input
                            type="number"
                            id="numVideos"
                            value={numVideos}
                            onChange={handleNumVideosChange}
                            min="1"
                            max="5"
                            style={numberInputStyle}
                        />
                    </div>
                )}

                <div style={platformSelectionStyle}>
                    <h3 style={{ marginTop: 0, marginBottom: '10px' }}>Select Platforms:</h3>
                    {allPlatforms.map(platform => (
                        <label key={platform} style={platformCheckboxStyle}>
                            <input
                                type="checkbox"
                                value={platform}
                                checked={selectedPlatforms.includes(platform)}
                                onChange={() => handlePlatformChange(platform)}
                                style={{ marginRight: '5px' }}
                            />
                            {platform}
                        </label>
                    ))}
                </div>

                <form onSubmit={handleSubmit}>
                    {/* --- Start of Conditional Rendering for Email fields --- */}
                    {selectedPlatforms.includes('Email') && (
                        <>
                            <div style={formGroupStyle}>
                                <label htmlFor="emailSubject" style={labelStyle}>Email Subject:</label>
                                <input
                                    type="text"
                                    id="emailSubject"
                                    value={emailSubject}
                                    onChange={handleEmailSubjectChange}
                                    style={inputStyle}
                                    placeholder="Enter email subject"
                                />
                            </div>
                            <div style={formGroupStyle}>
                                <label htmlFor="emailHeading" style={labelStyle}>Email Heading (Optional):</label>
                                <input
                                    type="text"
                                    id="emailHeading"
                                    value={emailHeading}
                                    onChange={handleEmailHeadingChange}
                                    style={inputStyle}
                                    placeholder="Enter email heading"
                                />
                            </div>
                        </>
                    )}
                    {/* --- End of Conditional Rendering for Email fields --- */}

                    {(mediaType === 'Image' || mediaType === 'Both') &&
                        Array.from({ length: numImages }).map((_, index) => (
                            <div key={`image-${index}`} style={formGroupStyle}>
                                <label htmlFor={`image-${index}`} style={labelStyle}>Image {index + 1}:</label>
                                <input
                                    type="file"
                                    id={`image-${index}`}
                                    onChange={(e) => handleImageChange(e, index)}
                                    accept="image/*"
                                    style={inputStyle}
                                />
                                {images[index] && (
                                    <div>
                                        <img src={URL.createObjectURL(images[index])} alt={`Preview ${index + 1}`} style={imagePreviewStyle} />
                                    </div>
                                )}
                            </div>
                        ))}

                    {(mediaType === 'Video' || mediaType === 'Both') &&
                        Array.from({ length: numVideos }).map((_, index) => (
                            <div key={`video-${index}`} style={formGroupStyle}>
                                <label htmlFor={`video-${index}`} style={labelStyle}>Video {index + 1}:</label>
                                <input
                                    type="file"
                                    id={`video-${index}`}
                                    onChange={(e) => handleVideoChange(e, index)}
                                    accept="video/*"
                                    style={inputStyle}
                                />
                                {videos[index] && (
                                    <div>
                                        <video src={URL.createObjectURL(videos[index])} controls style={videoPreviewStyle} />
                                    </div>
                                )}
                            </div>
                        ))}

                    <div style={formGroupStyle}>
                        <label htmlFor="description" style={labelStyle}>Description:</label>
                        <textarea id="description" value={description} onChange={handleDescriptionChange} style={textareaStyle} placeholder="Write a caption..."></textarea>
                    </div>
                    <button
                        type="submit"
                        style={buttonStyle}
                        onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#0056b3'}
                        onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#007bff'}
                    >
                        Upload Post
                    </button>
                </form>

                <h2 style={{ ...headingStyle, marginTop: '30px', borderTop: '1px solid #eee', paddingTop: '20px' }}>Uploaded Posts</h2>
                {posts.length > 0 ? (
                    <div style={{ overflowX: 'auto' }}> {/* For responsive table */}
                        <table style={tableStyle}>
                            <thead>
                                <tr>
                                    <th style={tableHeaderCellStyle}>Media</th>
                                    <th style={tableHeaderCellStyle}>Description</th>
                                    {/* --- Conditionally render Email Subject/Heading columns --- */}
                                    {posts.some(post => post.emailSubject || post.emailHeading) && (
                                        <>
                                            <th style={tableHeaderCellStyle}>Email Subject</th>
                                            <th style={tableHeaderCellStyle}>Email Heading</th>
                                        </>
                                    )}
                                    <th style={tableHeaderCellStyle}>Platforms</th>
                                    <th style={tableHeaderCellStyle}>Upload Date & Time</th>
                                    <th style={tableHeaderCellStyle}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {posts.map((post, index) => (
                                    <tr
                                        key={post.id}
                                        style={index % 2 !== 0 ? tableRowEvenStyle : {}}
                                        onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
                                        onMouseOut={(e) => e.currentTarget.style.backgroundColor = index % 2 !== 0 ? tableRowEvenStyle.backgroundColor : ''}
                                    >
                                        <td style={tableCellStyle}>
                                            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                {post.images && post.images.map((img, idx) => (
                                                    <img key={`img-${idx}`} src={URL.createObjectURL(img)} alt={`Post Img ${idx + 1}`} style={imagePreviewStyle} />
                                                ))}
                                                {post.videos && post.videos.map((vid, idx) => (
                                                    <video key={`vid-${idx}`} src={URL.createObjectURL(vid)} controls style={videoPreviewStyle} />
                                                ))}
                                            </div>
                                        </td>
                                        <td style={tableCellStyle}>{post.description}</td>
                                        {/* --- Conditionally render Email Subject/Heading cell data --- */}
                                        {posts.some(p => p.emailSubject || p.emailHeading) && (
                                            <>
                                                <td style={tableCellStyle}>{post.emailSubject || '-'}</td>
                                                <td style={tableCellStyle}>{post.emailHeading || '-'}</td>
                                            </>
                                        )}
                                        <td style={tableCellStyle}>{post.platforms.join(', ')}</td>
                                        <td style={tableCellStyle}>{post.uploadDateTime}</td>
                                        <td style={tableCellStyle}>
                                            <button
                                                style={editButtonStyle}
                                                onClick={() => handleEdit(post.id)}
                                                onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#e0a800'}
                                                onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#ffc107'}
                                            >
                                                Edit
                                            </button>
                                            <button
                                                style={deleteButtonStyle}
                                                onClick={() => handleDelete(post.id)}
                                                onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#c82333'}
                                                onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#dc3545'}
                                            >
                                                Delete
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <p style={noPostsStyle}>No posts uploaded yet.</p>
                )}
            </div>
        </div>
    );
};

export default UploadPost;